// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper-34-0U","priceRow":"priceRow-ohEP6"};